var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{class:_vm.className,attrs:{"disabled":_vm.disabled},nativeOn:{"click":function($event){return _vm.checkout.apply(null, arguments)}}},[_vm._v("\n    "+_vm._s(_vm.btnText)+" \n")])}
var staticRenderFns = []

export { render, staticRenderFns }